import React from 'react';
import clsx from 'clsx';
import { NewsCardProps } from '@/components/card/types';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { Badge } from '@/components/badge/Badge';
import { Link } from '@/components/link/Link';
import { renameDomProps } from '@/utils/sanitizeDomProps';

const NewsCard: React.FC<NewsCardProps> = ({
  image,
  title,
  badge,
  link,
  className,
  ...rest
}) => {
  const renamedProps = renameDomProps(rest);
  return (
    <div
      className={clsx(
        'news-card relative flex h-full flex-row gap-4 overflow-hidden rounded-lg border border-stone-200 bg-white p-6 text-brand-700',
        className,
      )}
      {...renamedProps}
    >
      {image && (
        <div className="relative w-2/5 self-stretch overflow-hidden rounded-md">
          <div className="absolute left-0 top-0 h-full w-full">
            <BaseImage
              {...image}
              className="h-full"
              prerender={true}
              quality={30}
              sizes="(max-width: 640px) 40vw, (max-width: 1024px) 20vw, 220px"
            />
          </div>
        </div>
      )}

      <div
        className={clsx(
          'flex flex-shrink-0 flex-col justify-between gap-4',
          image ? 'w-3/5' : 'w-full',
        )}
      >
        <div className="gap flex flex-col gap-1">
          {badge && <Badge {...badge} />}

          <h3 className="text-lg font-normal text-brand-700">{title}</h3>
        </div>
        {link?.href && (
          <div className="flex self-end">
            <Link {...link}>{link.title}</Link>
          </div>
        )}
      </div>
    </div>
  );
};

NewsCard.displayName = 'NewsCard';

export default NewsCard;
